// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3Imoh","row":"Node_row__1IVty","label":"Node_label__3FRa4","footer":"Node_footer__3vuPh"};